const Form = () => {
  return (
    <div className="pt-10 pb-8">
      <div className="text-center">
        <h1 className="mx-auto sub-heading">Get In Touch</h1>
        <h1 className="heading">We shall call you right back</h1>
      </div>  
      <form action="https://formspree.io/f/xpwprjqo" method="POST">
        <div className="flex-col gap-4 flex-align-center sm:flex-row ">
          <div className="flex-1 w-full">
            <p>First Name</p>
            <input
              type="text"
              name="first_name"
              className="w-full border-2 border-black px-4 py-2 rounded"
              placeholder="First Name.."
              required
            />
          </div>
          <div className="flex-1 w-full">
            <p>Last Name</p>
            <input
              type="text"
              name="last_name"
              className="w-full border-2 border-black px-4 py-2 rounded"
              placeholder="Last Name.."
              required
            />
          </div>
          <div className="flex-1 w-full">
            <p>Phone Number</p>
            <input
              type="tel"
              name="phone"
              className="w-full border-2 border-black px-4 py-2 rounded"
              placeholder="Phone Number.."
              required
            />
          </div>
        </div>
        <div className="mt-4">
          <p>Email Address</p>
          <input
            type="email"
            name="email"
            className="w-full border-2 border-black px-4 py-2 rounded"
            placeholder="Email Address.."
            required
          />
        </div>
        <div className="mt-4">
          <p>Message</p>
          <textarea
            name="message"
            rows={4}
            className="w-full border-2 border-black px-4 py-2 rounded"
            placeholder="Message.."
            required
          ></textarea>
        </div>
        <div className="mt-4 flex-center-center">
          <button type="submit" className="btn btn-primary">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default Form;
